import { render, staticRenderFns } from "./_entry.vue?vue&type=template&id=1c45ae20&scoped=true&"
import script from "./_entry.vue?vue&type=script&lang=js&"
export * from "./_entry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45ae20",
  null
  
)

export default component.exports